import { render, staticRenderFns } from "./CheckoutPaymentSection.vue?vue&type=template&id=0cb65060"
import script from "./CheckoutPaymentSection.vue?vue&type=script&lang=ts"
export * from "./CheckoutPaymentSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb65060')) {
      api.createRecord('0cb65060', component.options)
    } else {
      api.reload('0cb65060', component.options)
    }
    module.hot.accept("./CheckoutPaymentSection.vue?vue&type=template&id=0cb65060", function () {
      api.rerender('0cb65060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/CheckoutPaymentSection.vue"
export default component.exports